import styles from "./Change.module.scss";
import closeIcon from "../../../../../assets/images/icons/close-grey.svg";
import MainTitle from "../../../../../components/ui/MainTitle/MainTitle";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { IUserSubscription } from "../../../../../models/UserSubscription";
import { useGetAllSubscriptionsQuery } from "../../../../../api/queries";
import { Form } from "antd";
import FormItemSelect from "../../../../../components/ui/FormItemSelect/FormItemSelect";
import CustomButton from "../../../../../components/ui/CustomButton/CustomButton";
import { useUserSubscriptionMutations } from "../../../../../api/mutations";
import { openSuccessMessage } from "../../../../../store/message/messageSlice";
import { handleError } from "../../../../../helper/errorHandler";
import useAppDispatch from "../../../../../hooks/useAppDispatch";

interface IChangeProps {
  closePopup: () => void;
  userSubscription: IUserSubscription;
  refetch: () => void;
}

const Change: React.FC<IChangeProps> = ({ closePopup, userSubscription, refetch }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { change } = useUserSubscriptionMutations();

  const { data: subscription = [] } = useGetAllSubscriptionsQuery(null);

  const filteredSubscriptionsForSelect = useMemo(() => {
    return subscription
      .filter(
        (subscription) =>
          subscription.id !== userSubscription.subscriptionId && subscription.isVisible
      )
      .map((subscription) => ({ id: subscription.id, label: subscription.name }));
  }, [subscription]);

  const onFinish = (values: { subscriptionId: string }) => {
    change(
      { subscriptionId: values.subscriptionId, userId: userSubscription.userId },
      {
        onSuccess: () => {
          dispatch(openSuccessMessage(t("SubscriptionChangedSuccessfully")));
          closePopup();
          refetch();
        },
        onError: (e) => handleError(e, dispatch, t),
      }
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.popup}>
        <button onClick={closePopup} className={styles.closeBtn}>
          <img src={closeIcon} alt="close" />
        </button>
        <MainTitle size={20} text={t("ChangeSubscription")} />

        <Form
          className={"form"}
          name="gym-listing-filter"
          onFinish={onFinish}
          autoComplete="off"
          layout={"vertical"}
        >
          <FormItemSelect
            name={"subscriptionId"}
            label={t("SelectSubscription")}
            rules={{ required: true }}
            items={filteredSubscriptionsForSelect}
          />
          <div className={styles.btnWrapper}>
            <CustomButton
              style={{
                width: "50%",
              }}
              text={t("Change")}
              type={"submit"}
              typeStyle={"fill"}
            />
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Change;
